import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SeamlessMigrationToDynamics365BusinessCentral from "./sections/SeamlessMigrationToDynamics365BusinessCentral";
import WhyChooseGp2bcExpress from "./sections/WhyChooseGp2bcExpress";
import OurProvenMigrationFramework from "./sections/OurProvenMigrationFramework";
import AuditReadyReporting from "./sections/AuditReadyReporting";
import ScalablePricingTiers from "./sections/ScalablePricingTiers";
import ClientReadyDocumentation from "./sections/ClientReadyDocumentation";
import GetAFreeMigrationAssessment from "./sections/GetAFreeMigrationAssessment";
import Footer from "@/reusable_sections/Footer";
import CurrencyExchangeSavings from "./sections/CurrencyExchangeSavings";
export default function HomePage() {
  return <div>
      <Header />
      <SeamlessMigrationToDynamics365BusinessCentral />
      <WhyChooseGp2bcExpress />
      <OurProvenMigrationFramework />
      <AuditReadyReporting />
      <ScalablePricingTiers />
      <ClientReadyDocumentation />
      <GetAFreeMigrationAssessment />
      <CurrencyExchangeSavings />
      <Footer />
    </div>;
}